import DOMPurify from 'dompurify';

const SanitisedHtml = ({html, as: Tag = 'div'}) => {
    return <Tag dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }} />
}

export default SanitisedHtml